// @flow

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import MemberUtils from 'web-core/src/utils/member';
import { getName, type NamePropsType } from './getName';

type Props = {
  memberNames: Array<NamePropsType>,
  useFullLast?: boolean,
  applicantNames: {
    primary: string,
    spouse: string,
    dependent: string,
  },
};

const mapStateToProps = ({ translations }) => ({
  applicantNames: _.get(translations, 'common.member.name', {}),
});

export class MemberNamesUI extends PureComponent<Props> {
  static defaultProps = {
    useFullLast: false,
  };

  render() {
    const { applicantNames, memberNames, useFullLast } = this.props;

    const names = MemberUtils.sortMembers(memberNames).map((nameInfo, index) => {
      const { last_name } = nameInfo;
      let name;

      if (useFullLast === true) {
        name = getName({ member: nameInfo, applicantNames });
      } else {
        const newNameInfo = Object.assign({}, nameInfo);

        if (last_name) {
          newNameInfo.last_name = `${last_name[0]}.`;
        }

        name = getName({ member: newNameInfo, applicantNames });
      }

      const lastIndex = this.props.memberNames.length - 1;
      switch (index) {
        case 0:
          return name;
        case lastIndex:
          return ` & ${name}`;
        default:
          return `, ${name}`;
      }
    });

    return <span>{names.join('')}</span>;
  }
}

export default connect(mapStateToProps, {})(MemberNamesUI);
